import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AuthProvider from '../components/authProvider';
import { AuthContextProvider } from './AuthContextProvider';
import { AvCopilotContextProvider } from './AvCopilotProvider';
import AvSnackBarProvider from './AvSnackBarProvider';
import { DataContextProvider } from './DataContextProvider';
import { FabricUIProvider } from './FabricUIProvider';
import LayoutContextProvider from './LayoutContext';
import { NavigationBlockerProvider } from './NavigationBlockerProvider';
import SearchContextProvider from './SearchContextProvider';
import { ContextProviderComponent } from './types';

const LocalizationDateFnsProvider: ContextProviderComponent = ({ children } = {}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>{children}</LocalizationProvider>
);

// Order matters!
export const Providers = {
  AuthProvider,
  AuthContextProvider,
  NavigationBlockerProvider,
  DataContextProvider,
  AvSnackBarProvider,
  LocalizationDateFnsProvider,
  LayoutContextProvider,
  AvCopilotContextProvider,
  SearchContextProvider,
  FabricUIProvider,
} as const satisfies Record<string, ContextProviderComponent>;

export const createRootContext = (providers: ContextProviderComponent[]) =>
  function RootContext({ children }: React.PropsWithChildren) {
    return providers.reduceRight((acc, ProviderComponent) => <ProviderComponent>{acc}</ProviderComponent>, children);
  };

const RootContext = createRootContext(Object.values(Providers));

export default RootContext;
